import * as d3 from 'd3'

var redGreenGradient = {
  colors: [
    '#fd0001',
    '#fd0101',
    '#fc0101',
    '#fa0101',
    '#f90103',
    '#f70203',
    '#f60203',
    '#f40204',
    '#f20304',
    '#f10304',
    '#ef0404',
    '#ee0405',
    '#ec0405',
    '#ea0505',
    '#e80505',
    '#e70506',
    '#e50606',
    '#e30706',
    '#e20706',
    '#e00807',
    '#df0708',
    '#dd0808',
    '#db0808',
    '#d90809',
    '#d80909',
    '#d60909',
    '#d40a09',
    '#d30a0a',
    '#d10a0a',
    '#cf0a0a',
    '#ce0b0b',
    '#cc0b0b',
    '#cb0c0b',
    '#c90b0c',
    '#c70c0c',
    '#c60c0c',
    '#c40c0d',
    '#c20d0d',
    '#c10e0e',
    '#bf0e0e',
    '#be0e0e',
    '#bc0f0f',
    '#ba0f0f',
    '#b90f10',
    '#b71010',
    '#b51010',
    '#b41010',
    '#b21111',
    '#b11111',
    '#af1111',
    '#ad1112',
    '#ab1212',
    '#aa1212',
    '#a81313',
    '#a61313',
    '#a51313',
    '#a31413',
    '#a21414',
    '#a01514',
    '#9e1414',
    '#9d1515',
    '#9b1616',
    '#9a1616',
    '#981616',
    '#961716',
    '#951717',
    '#931717',
    '#911818',
    '#8f1818',
    '#8e1818',
    '#8d1919',
    '#8b1919',
    '#8a1a1a',
    '#881a19',
    '#861b1a',
    '#841b1b',
    '#831b1b',
    '#811c1b',
    '#801c1b',
    '#7e1c1c',
    '#7c1d1c',
    '#7a1d1d',
    '#791d1d',
    '#781d1e',
    '#761e1e',
    '#741f1e',
    '#721f1e',
    '#711f1f',
    '#6f1f1f',
    '#6e1f20',
    '#6c1f20',
    '#6a2020',
    '#682020',
    '#682221',
    '#662222',
    '#652222',
    '#622323',
    '#612223',
    '#602323',
    '#5e2323',
    '#5c2424',
    '#5a2425',
    '#582424',
    '#572525',
    '#552525',
    '#542626',
    '#522627',
    '#502626',
    '#4e2627',
    '#4d2727',
    '#4b2728',
    '#4a2828',
    '#482828',
    '#462929',
    '#452929',
    '#432929',
    '#422a29',
    '#40292a',
    '#3f2a2a',
    '#3d2b2b',
    '#3b2b2b',
    '#3a2b2c',
    '#372c2c',
    '#362c2c',
    '#352d2c',
    '#332d2d',
    '#312d2e',
    '#302e2e',
    '#2f2f2f',
    '#2e312f',
    '#2f322e',
    '#2e332e',
    '#2e342d',
    '#2d372d',
    '#2c372c',
    '#2d392c',
    '#2c3a2b',
    '#2b3b2c',
    '#2b3d2c',
    '#2b3e2b',
    '#2a3f2a',
    '#2a412a',
    '#29432a',
    '#294429',
    '#294529',
    '#284728',
    '#284828',
    '#284a27',
    '#284b27',
    '#274d27',
    '#264e27',
    '#265026',
    '#265126',
    '#265326',
    '#255425',
    '#245625',
    '#245725',
    '#245825',
    '#245a24',
    '#245b24',
    '#245d24',
    '#235e23',
    '#236023',
    '#226123',
    '#226322',
    '#226421',
    '#216621',
    '#216721',
    '#216821',
    '#206920',
    '#1f6b20',
    '#1f6d1f',
    '#1f6f1f',
    '#1e701f',
    '#1e711e',
    '#1d721e',
    '#1d741e',
    '#1e751e',
    '#1d771e',
    '#1d781d',
    '#1d7a1d',
    '#1c7c1c',
    '#1c7d1c',
    '#1b7e1c',
    '#1b801b',
    '#1a811b',
    '#1a821b',
    '#1a841a',
    '#1a851b',
    '#198719',
    '#198819',
    '#188919',
    '#188b18',
    '#188d18',
    '#178e18',
    '#168f17',
    '#169117',
    '#179217',
    '#169316',
    '#159416',
    '#159616',
    '#159815',
    '#159914',
    '#149b14',
    '#139c14',
    '#139e13',
    '#129f13',
    '#12a013',
    '#12a213',
    '#12a312',
    '#11a411',
    '#10a611',
    '#10a711',
    '#10a911',
    '#10ab11',
    '#0fac11',
    '#0fae10',
    '#0faf10',
    '#0fb00f',
    '#0eb20f',
    '#0eb30e',
    '#0eb40e',
    '#0db60e',
    '#0cb70d',
    '#0cb90d',
    '#0cbb0c',
    '#0bbc0d',
    '#0bbe0c',
    '#0bbf0c',
    '#0ac00b',
    '#0ac10b',
    '#0ac30a',
    '#0ac40a',
    '#09c609',
    '#09c709',
    '#09c809',
    '#08ca08',
    '#07cb08',
    '#07cd08',
    '#07cf08',
    '#06d008',
    '#06d107',
    '#06d306',
    '#05d406',
    '#04d505',
    '#04d605',
    '#04d805',
    '#04d904',
    '#03da04',
    '#03dc03',
    '#03dd04',
    '#02df03',
    '#02e002',
    '#01e202',
    '#01e302',
    '#00e402',
  ],
  nullColor: '#2f323d',
}

var futuresDomains = {
  d: 1.5,
  w: 2.5,
  m: 5,
  mtd: 5,
  q: 10,
  hy: 25,
  y: 30,
  ytd: 30,
}

var forexDomains = {
  d: 1,
  w: 2.5,
  m: 5,
  mtd: 5,
  q: 10,
  hy: 10,
  y: 10,
  ytd: 10,
}

var cryptoDomains = {
  d: 5, // TODO refine
  w: 2.5,
  m: 5,
  mtd: 5,
  q: 10,
  hy: 10,
  y: 10,
  ytd: 10,
}

var generateColorScale = function (domains: Record<string, number>, domainId: string, gradient = redGreenGradient) {
  var domain = {
    min: -domains[domainId],
    max: +domains[domainId],
  }

  var linearScale = d3
    .scaleLinear()
    .domain([domain.min, domain.max])
    .range([0, gradient.colors.length - 1])

  return function (value: number) {
    if (typeof value === 'undefined' || value === null) {
      return gradient.nullColor
    }

    if (value > domain.max) value = domain.max
    if (value < domain.min) value = domain.min

    var i = Math.round(linearScale(value))
    return gradient.colors[i]
  }
}

var getCookie = function (name: string) {
  var re = new RegExp('(?:(?:^|.*;\\s*)' + name + '\\s*\\=\\s*([^;]*).*$)|^.*$')
  return document.cookie.replace(re, '$1')
}

export const layout = [
  ['YM', 'ES', 'NQ', 'ER2', 'NKD', 'EX', 'DY', 'VX'],
  ['CL', 'QA', 'RB', 'HO', 'NG', 'ZK'],
  ['ZB', 'ZN'],
  ['CC', 'CT', 'JO', 'KC', 'LB', 'SB'],
  ['ZF', 'ZT'],
  ['GC', 'SI', 'PL', 'HG', 'PA'],
  ['LC', 'FC', 'LH'],
  ['ZS', 'ZM', 'ZL', 'ZC', 'ZW', 'ZR', 'ZO', 'RS'],
  ['DX', '6E', '6J', '6B', '6C', '6S', '6A', '6N'],
]

export const groups = ['Indices', 'Energy', 'Bonds', 'Softs', 'Metals', 'Meats', 'Grains', 'Currencies'] as const

export { generateColorScale, futuresDomains, forexDomains, cryptoDomains, getCookie }
